import React, { useState, useEffect } from "react";

const CustomBootstrapModal = ({
  show,
  setShow,
  title,
  onClose,
  onSave,
  hasFooter = true,
  children,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [show]);

  const handleClose = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onClose?.();
    setLoading(false);
    setShow(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSave?.();
    setLoading(false);
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">{children}</div>

            {hasFooter && (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                  disabled={loading}
                >
                  {loading ? "Closing..." : "Close"}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save changes"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
    </>
  );
};

export default CustomBootstrapModal;
